import { ReferenceOption, UpdateApproachReference } from './types';

const updateApproachReference: UpdateApproachReference = ({
  approaches,
  column,
  lookup,
  specificApproachKey,
  updateKey,
  referenceKey,
  extraOptions = [],
}) => {
  const tmpColumn = column;
  // find the id of the approach. Can either match the panel id of the id of the specific approach
  const options = [...approaches, ...extraOptions] as ReferenceOption[];
  const selectedOption = options.find(
    option =>
      option.panelId === lookup ||
      option[specificApproachKey]?.id.toString() === lookup.toString() ||
      option.id === Number(lookup)
  );
  // if the approach has been saved, grab the id of the gpc approach,
  // else set it to null if no approach is found or the approach is not saved
  if (selectedOption?.[specificApproachKey]?.id) {
    tmpColumn[updateKey] = selectedOption.valuations_approach_gpc.id;
  } else if (selectedOption?.id === 0) {
    tmpColumn[updateKey] = null;
  } else {
    tmpColumn[updateKey] = null;
  }
  // always set the reference. Can be null if no approach was found
  tmpColumn[referenceKey] = selectedOption?.panelId ?? null;
};
export default updateApproachReference;
